const track = (data = {}) => {
  if (!window.dataLayer) {
    window.dataLayer = [];
  }

  return new Promise(resolve => {
    window.dataLayer.push({ ...data, eventCallback: resolve, eventTimeout: 2000 });
    setTimeout(resolve, 2100);
  });
};

export default { track };
